import React from 'react';

const formatValue = (value) => {
  if (value === null || value === undefined || value === '' || value === 'null')
    return '-';
  return String(value);
};

function ReceiversTable({ receivers }) {
  return (
    <div className='tw-flex tw-items-center tw-w-full tw-rounded-lg tw-border tw-border-1 tw-border-solid tw-border-grey-200 tw-overflow-x-auto tw-bg-white'>
      <div
        className='tw-text-base tw-w-full tw-flex tw-flex-col tw-leading-none tw-gap-4'
        style={{ fontWeight: 300 }}
      >
        <table className='tw-rounded-xl tw-border-none tw-table-fixed'>
          <thead className='tw-rounded-xl'>
            <tr className='tw-rounded-2xl'>
              {[
                { title: 'Customer ID', width: '33.33%' },
                { title: 'Name', width: '33.33%' },
                { title: 'Quantity', width: '33.34%' },
              ].map((col) => (
                <th
                  title={col.title}
                  key={col.title}
                  className={`tw-w-[${col.width}] tw-p-3 tw-bg-blue-200 tw-text-grey-600 tw-text-center tw-whitespace-nowrap tw-overflow-hidden tw-text-ellipsis tw-text-base`}
                  style={{ fontWeight: 300 }}
                >
                  {col.title}
                </th>
              ))}
            </tr>
          </thead>
          <tbody className='tw-bg-white'>
            {receivers.map((receiver, index) => (
              <tr
                key={index}
                className={
                  index === receivers.length - 1
                    ? 'tw-rounded-b-xl tw-border-none tw-shadow-none tw-text-grey-600 tw-text-center'
                    : 'tw-text-grey-600 tw-text-center tw-shadow-none tw-border tw-border-solid tw-border-grey-200 !tw-border-l-0 !tw-border-r-0'
                }
              >
                <td
                  className='tw-p-4 tw-border-r tw-border-solid tw-overflow-hidden tw-text-ellipsis tw-border-y-0 tw-border-l-0 tw-border-grey-200 tw-whitespace-nowrap tw-text-center tw-text-base'
                  style={{ fontWeight: 300 }}
                >
                  {formatValue(receiver.id)}
                </td>
                <td
                  className='tw-p-4 tw-border-r tw-border-solid tw-border-y-0 tw-border-l-0 tw-border-grey-200 tw-whitespace-nowrap tw-text-center tw-overflow-hidden tw-text-ellipsis tw-text-base'
                  style={{ fontWeight: 300 }}
                  data-dd-privacy='mask'
                >
                  {formatValue(receiver.name)}
                </td>
                <td
                  className='tw-p-4 tw-text-center tw-text-base'
                  style={{ fontWeight: 300 }}
                >
                  {formatValue(receiver.quantity)}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}

export default ReceiversTable;
